import { createBrowserRouter, Navigate } from 'react-router-dom'
import { useAuthStore } from './store/authStore'
import AppShell from './components/layout/AppShell'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Cargas from './pages/Cargas'
import CargaDetail from './pages/CargaDetail'
import Mapa from './pages/Mapa'
import Outliers from './pages/Outliers'
import Operadores from './pages/Operadores'
import Vehiculos from './pages/Vehiculos'
import Tanques from './pages/Tanques'
import Reportes from './pages/Reportes'
import Settings from './pages/Settings'
import Onboarding from './pages/Onboarding'
import Geofences from './pages/Geofences'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const token = useAuthStore.getState().token
  if (!token) return <Navigate to="/login" replace />
  return <>{children}</>
}

export const router = createBrowserRouter(
  [
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/onboarding',
    element: (
      <ProtectedRoute>
        <Onboarding />
      </ProtectedRoute>
    ),
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AppShell />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'cargas', element: <Cargas /> },
      { path: 'cargas/:id', element: <CargaDetail /> },
      { path: 'mapa', element: <Mapa /> },
      { path: 'outliers', element: <Outliers /> },
      { path: 'operadores', element: <Operadores /> },
      { path: 'vehiculos', element: <Vehiculos /> },
      { path: 'tanques', element: <Tanques /> },
      { path: 'geofences', element: <Geofences /> },
      { path: 'reportes', element: <Reportes /> },
      { path: 'settings', element: <Settings /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
  ],
  { basename: import.meta.env.BASE_URL.replace(/\/$/, '') || '/' },
)
